@if (isMobile) {
  <app-assessment-mobile
    [user]="user"
    [assessment]="assessment"
    [assessments]="assessments"
    [selectedAssessment]="selectedAssessment"
    [keyActionEvaluations]="keyActionEvaluations"
    [selectedKeyAction]="selectedKeyAction"
    [showSummary]="showSummary"
    [overallScoreLabel]="overallScoreLabel"
    [speakerLabelValues]="speakerLabelValues"
    [adminOrg]="adminOrg"
    [downloadUrl]="downloadUrl"
    (assessmentChange)="changeAssessment($event)"
    (keyActionSelect)="selectKeyAction($event)"
    (summaryToggle)="toggleSummary()"
    (contentAccessed)="markContentAsAccessed($event)"
    (transcriptDownload)="exportTranscriptText()"
  ></app-assessment-mobile>
} @else {
  <div class="container">
    <div class="overall" [class.collapsed]="this.collapsed">
      <button class="toggle-button" (click)="this.collapsed = !this.collapsed">
        <mat-icon>
          {{ this.collapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}
        </mat-icon>
      </button>
      <div
        class="collapsable"
        [style.visibility]="this.collapsed ? 'hidden' : 'visible'"
      >
        <div class="user">
          <div class="avatar-wrapper">
            <app-avatar
              [thumbnailUrl]="this.user?.thumbnailPath ?? ''"
            ></app-avatar>
          </div>
          <div class="name">{{ this.user?.name }}</div>
          <div class="department">{{ this.user?.departmentName }}</div>
        </div>
        <app-loading
          [showLoading]="
            !!this.assessment && this.assessment.status === 'IN_PROGRESS'
          "
        ></app-loading>
        @if (this.assessment) {
          <app-assessment-tags
            [assessment]="this.assessment"
          ></app-assessment-tags>
        }
        @if (
          this.assessment &&
          this.assessment.status === 'COMPLETED' &&
          this.assessment.skipEvaluation
        ) {
          <div class="skip-evaluation-notice">
            <div class="title">評価なし</div>
            <div class="description">
              文字起こしのみで完了したアセスメントです。
            </div>
          </div>
        } @else if (this.assessment && this.assessment.status === 'COMPLETED') {
          <div class="score-wrapper">
            <div class="title">{{ overallScoreLabel }}</div>
            <div class="score">
              <!-- GRADE モード: overallGrade を表示。
              閾値未マッチで null になった場合は『—』プレースホルダで表示する
              (要件「具体的な点数を見せない」を遵守、admin 警告 UI で運用検知) -->
              @if (this.assessment.overallScoreLogicType === 'GRADE') {
                <span class="grade-display">{{
                  this.assessment.overallGrade ?? '—'
                }}</span>
              } @else {
                @if (
                  this.assessment.overallScoreLogicType === 'WEIGHTED' &&
                  this.assessment.denominator != null
                ) {
                  {{ this.assessment.overallScore | number: '1.0-0' }} /
                  {{ this.assessment.denominator | number: '1.0-0' }}
                } @else {
                  @if (this.assessment.overallScoreLogicType === 'WEIGHTED') {
                    {{ this.assessment.overallScore | number: '1.0-0' }}
                    <span class="weighted-score-suffix">点</span>
                  } @else {
                    {{ this.assessment.overallScore | number: '1.2-2' }}
                  }
                }
              }
            </div>
          </div>
          @if (categoryScores.length > 0) {
            <div class="category-scores">
              <div class="title">カテゴリ別スコア</div>
              <div class="list">
                @for (item of categoryScores; track item) {
                  <div class="item" [class.special-tenant]="isSpecialTenant()">
                    <div class="category">{{ item.category }}</div>
                    <div class="score">
                      {{ item.average | number: '1.2-2' }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <div class="widget">
            <ng-container>
              @if (!isSpecialTenant()) {
                <div class="high-light card">
                  <div class="title">
                    <div class="label">
                      <div class="badge">TOP 3</div>
                      <div class="text">良かった点</div>
                    </div>
                  </div>
                  <div class="list">
                    @for (highLight of this.highLights; track highLight) {
                      <div class="item">
                        <div class="key-action">
                          <div class="badge">
                            {{ highLight.keyAction.alias
                            }}<span class="circle green">●</span>
                          </div>
                          <div
                            class="text"
                            [matTooltip]="highLight.keyAction.name"
                          >
                            {{ highLight.keyAction.name }}
                          </div>
                        </div>
                        <div class="score">
                          {{ highLight.score | number: '1.2-2' }}
                        </div>
                      </div>
                    }
                    @if (this.highLights.length === 0) {
                      <div class="empty">該当なし</div>
                    }
                  </div>
                </div>
              }
              @if (!isSpecialTenantWithCategories()) {
                <div class="low-light card">
                  <div class="title">
                    <div class="label">
                      @if (!isSpecialTenantWithoutCategories()) {
                        <div class="badge">TOP 3</div>
                      }
                      <div class="text">改善したい点</div>
                    </div>
                  </div>
                  <div class="list">
                    @for (lowLight of this.lowLights; track lowLight) {
                      <div class="item">
                        <div class="key-action">
                          <div class="badge">
                            {{ lowLight.keyAction.alias
                            }}<span class="circle orange">●</span>
                          </div>
                          <div
                            class="text"
                            [matTooltip]="lowLight.keyAction.name"
                          >
                            {{ lowLight.keyAction.name }}
                          </div>
                        </div>
                        <div class="score">
                          {{ lowLight.score | number: '1.2-2' }}
                        </div>
                      </div>
                    }
                    @if (this.lowLights.length === 0) {
                      <div class="empty">該当なし</div>
                    }
                  </div>
                </div>
              }
            </ng-container>
            @if (isSpecialTenantWithCategories()) {
              @if (getCategoryImprovements().length > 0) {
                <div class="category-improvements">
                  <div class="title">カテゴリ別改善点</div>
                  <div class="category-list">
                    @for (group of getCategoryImprovements(); track group) {
                      <div class="category-item special-tenant">
                        <div class="category-header">{{ group[0] }}</div>
                        <div class="improvement-list">
                          @for (improvement of group[1]; track improvement) {
                            <div class="item">
                              <div class="key-action">
                                <div class="badge">
                                  {{ improvement.keyAction.alias
                                  }}<span class="circle orange">●</span>
                                </div>
                                <div
                                  class="text"
                                  [matTooltip]="improvement.keyAction.name"
                                >
                                  {{ improvement.keyAction.name }}
                                </div>
                              </div>
                              <div class="score">
                                {{ improvement.score | number: '1.2-2' }}
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
    </div>
    <div class="main">
      <div class="main-header">
        <div class="left">
          <div class="select-wrapper">
            <span class="select-label">商談</span>
            <app-select
              (selectedOptionChange)="this.changeAssessment($event)"
              [options]="this.assessments"
              [selectedOption]="this.selectedAssessment"
            ></app-select>
          </div>
          @if (!this.isNotSet()) {
            <button
              rectangle
              variant="secondary"
              class="register-info"
              (click)="this.showRegisterInformation()"
            >
              詳細
            </button>
          }
          @if (this.assessment) {
            <app-context-menu
              [menus]="this.contextMenu"
              (clicked)="contextMenuClick($event)"
            >
            </app-context-menu>
          }
        </div>
        <div class="upload-button-wrapper">
          <button
            rectangle
            (click)="this.startUploadingFile()"
            [disabled]="
              (!this.isSelfUser() &&
                !this.isDirectManager() &&
                !this.isEnablerOrAdmin()) ||
              !this.hasLicense()
            "
          >
            <mat-icon>upload</mat-icon>
            ファイルをアップロード
          </button>
        </div>
      </div>
      @if (!!this.assessment) {
        <div class="result">
          @if (this.assessment.status === 'FAILED') {
            <div>
              <strong>アセスメント中にエラーが発生しました</strong>
              <p>
                アップロードしたファイルに問題ないかご確認のうえ、再度お試しください。
                改善しない場合は開発チームまでご連絡お願いします。
              </p>
            </div>
          }
          @if (this.assessment.status !== 'FAILED') {
            <div class="content">
              <div class="content-body">
                @if (this.showEvaluationPanel) {
                  <div class="key-action-filter">
                    @if (
                      this.assessment.businessMeeting.summaryStatus !== 'FAILED'
                    ) {
                      <button
                        rectangle
                        [variant]="showSummary ? 'primary' : 'secondary'"
                        class="summary-button"
                        (click)="toggleSummary()"
                      >
                        <mat-icon class="material-icons-outlined"
                          >assignment</mat-icon
                        >
                        サマリー
                      </button>
                    }
                    @if (!this.assessment.skipEvaluation) {
                      @for (
                        evaluation of this.keyActionEvaluations;
                        track evaluation
                      ) {
                        <button
                          rectangle
                          [variant]="
                            !this.showSummary &&
                            this.selectedKeyAction?.id === evaluation.id
                              ? 'primary'
                              : 'secondary'
                          "
                          class="key-action-button"
                          (click)="this.selectKeyAction(evaluation.id)"
                        >
                          <div
                            class="key-action"
                            [ngClass]="{
                              active:
                                !this.showSummary &&
                                this.selectedKeyAction?.id === evaluation.id,
                            }"
                          >
                            {{ evaluation.keyAction.alias
                            }}<span
                              class="circle"
                              [class]="{
                                green: isHighlight(evaluation),
                                orange: isLowLight(evaluation),
                              }"
                              >●</span
                            >
                          </div>
                        </button>
                      }
                    }
                  </div>
                }
                <div class="evaluation-wrapper">
                  @if (this.showEvaluationPanel) {
                    <div class="evaluation-section">
                      <div class="evaluation">
                        <app-ai-badge></app-ai-badge>
                        @if (showSummary) {
                          <div class="summary">
                            @if (
                              this.assessment.businessMeeting.summaryStatus ===
                              'COMPLETED'
                            ) {
                              <div class="summary-header">
                                <div class="summary-title">商談の背景</div>
                                <button
                                  type="button"
                                  class="copy-button"
                                  (click)="
                                    copyToClipboard(
                                      this.assessment.businessMeeting.summary
                                    )
                                  "
                                >
                                  <mat-icon class="material-icons-outlined"
                                    >file_copy</mat-icon
                                  >
                                </button>
                              </div>
                              <div class="summary-content">
                                <div
                                  class="summary-text"
                                  [innerHTML]="
                                    this.assessment.businessMeeting.summary
                                      | markdown
                                  "
                                ></div>
                              </div>
                            }
                            @if (
                              this.assessment.businessMeeting.summaryStatus ===
                              'PENDING'
                            ) {
                              <div class="summary-content">
                                <div class="summary-text">
                                  要約を生成中です。時間をおいて再度ご確認ください。
                                </div>
                              </div>
                            }
                            @if (
                              this.assessment.businessMeeting.summaryStatus ===
                              'FAILED'
                            ) {
                              <div class="summary-content">
                                <div class="summary-text">
                                  要約の生成に失敗しました。
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (
                          !this.showSummary && !this.assessment.skipEvaluation
                        ) {
                          <div class="key-action">
                            <div class="key-action-title">
                              <div class="key-action-label">
                                {{ this.selectedKeyAction?.keyAction?.alias }}
                              </div>
                              <div class="key-action-name">
                                {{ this.selectedKeyAction?.keyAction?.name }}
                              </div>
                            </div>
                            @if (this.selectedKeyAction?.score != null) {
                              <div class="key-action-score">
                                {{
                                  $safeNavigationMigration(
                                    this.selectedKeyAction?.score
                                  ) | number: '1.2-2'
                                }}
                              </div>
                            }
                          </div>
                          <div class="evaluation-content" #evaluation>
                            <div
                              class="evaluation-text"
                              [innerHTML]="
                                $safeNavigationMigration(
                                  this.selectedKeyAction?.evaluation
                                ) | markdown
                              "
                            ></div>
                            <div class="recommendation-container">
                              @if (
                                this.selectedKeyAction?.recommendedContents
                                  ?.length
                              ) {
                                <div class="recommendation">
                                  <div class="header">
                                    <div class="badge">おすすめコンテンツ</div>
                                  </div>
                                  <div class="recommendation-content-wrapper">
                                    @for (
                                      recommendation of this.selectedKeyAction
                                        ?.recommendedContents;
                                      track recommendation
                                    ) {
                                      <div class="recommendation-content">
                                        <div class="content">
                                          <a
                                            class="content-link"
                                            [href]="recommendation.content.url"
                                            (click)="
                                              this.markContentAsAccessed(
                                                recommendation.id
                                              )
                                            "
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            >{{
                                              recommendation.content.name
                                            }}</a
                                          >
                                          <mat-icon class="icon">{{
                                            recommendation.isAccessed
                                              ? 'check_circle_filled'
                                              : 'play_circle_outline'
                                          }}</mat-icon>
                                        </div>
                                      </div>
                                    }
                                    @if (
                                      this.selectedKeyAction
                                        ?.recommendedContents?.length === 0
                                    ) {
                                      <span>該当なし</span>
                                    }
                                  </div>
                                </div>
                              }
                              @if (
                                this.selectedKeyAction?.roleModelAssessments
                                  ?.length &&
                                this.adminOrg?.useRoleModelRecommendation
                              ) {
                                <div class="recommendation">
                                  <div class="header">
                                    <div class="badge">ロールモデル商談</div>
                                  </div>
                                  <div class="recommendation-content-wrapper">
                                    @for (
                                      assessment of this.selectedKeyAction
                                        ?.roleModelAssessments;
                                      track assessment
                                    ) {
                                      <div class="recommendation-content">
                                        <div class="content">
                                          <a
                                            class="content-link"
                                            [routerLink]="['/home']"
                                            [queryParams]="{
                                              'assessment-id': assessment.id,
                                              'key-action-id':
                                                $safeNavigationMigration(
                                                  this.selectedKeyAction
                                                    ?.keyAction?.id
                                                ),
                                              'user-id': assessment.user.id,
                                            }"
                                            target="_blank"
                                          >
                                            {{
                                              getRoleModelAssessmentTitle(
                                                assessment
                                              )
                                            }}
                                          </a>
                                        </div>
                                      </div>
                                    }
                                    @if (
                                      this.selectedKeyAction
                                        ?.roleModelAssessments?.length === 0
                                    ) {
                                      <span>該当なし</span>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div
                    class="transcript-section"
                    [class.transcript-only]="!this.showEvaluationPanel"
                  >
                    @if (
                      this.isMediaFile() &&
                      this.assessment.status === 'COMPLETED'
                    ) {
                      <div class="media-space">
                        @if (this.downloadUrl) {
                          <audio controls #audioPlayer preload="none">
                            <source
                              src="{{ this.downloadUrl }}"
                              type="{{ this.getMimeType(this.downloadUrl) }}"
                            />
                          </audio>
                        }
                      </div>
                    }
                    <div class="transcript">
                      <div class="transcript-title">文字起こし</div>
                      <div class="transcript-content" tabindex="-1" #transcript>
                        @for (
                          speak of this.assessment?.businessMeeting?.transcript;
                          track speak
                        ) {
                          <div class="speak">
                            <button
                              [ngClass]="{
                                'cursor-default': !this.isMediaFile(),
                              }"
                              class="speak-info"
                              [attr.data-speaked-at]="speak.speakedAt"
                              (click)="this.seekTo(speak.speakedAt)"
                              [tabIndex]="this.isMediaFile() ? 0 : -1"
                              [ariaDisabled]="!this.isMediaFile()"
                            >
                              <div class="speaker">
                                {{
                                  speak.speaker
                                    | speakerLabel: this.speakerLabelValues
                                }}
                              </div>
                              <div class="speaked-at">
                                {{ speak.speakedAt }}
                              </div>
                              @if (this.isMediaFile()) {
                                <div class="audio">
                                  <mat-icon>volume_up</mat-icon>
                                </div>
                              }
                            </button>
                            @if (speak.content) {
                              <div class="content-info">
                                @if (speak.content.assessment) {
                                  <span
                                    class="assessment-badge"
                                    [attr.data-level]="speak.content.assessment"
                                    >{{ speak.content.assessment }}</span
                                  >
                                }
                                @if (speak.content.reason) {
                                  <span class="reason">{{
                                    speak.content.reason
                                  }}</span>
                                }
                                @if (speak.content.reasonDetail) {
                                  <span class="reason-detail">{{
                                    speak.content.reasonDetail
                                  }}</span>
                                }
                              </div>
                            }
                            <div class="quote">{{ speak.quote }}</div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (this.assessment?.status === 'IN_PROGRESS') {
            <div class="custom-loader-wrapper" aria-busy="true">
              <div>
                <div class="custom-loader"></div>
                <div class="custom-loader-title">
                  {{
                    this.assessment?.skipEvaluation
                      ? '処理中...'
                      : 'アセスメント実行中...'
                  }}
                </div>
                <div class="custom-loader-description">
                  完了には時間がかかります。時間をおいて、再度ご確認ください。
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
